import React, { useEffect } from "react";

import AccountProfile from "../components/AccountProfile/AccountProfile";
import i18n from "../i18n/config";

const PerfilPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("layoutTitle", { ns: "accountProfile" })}`;
  }, []);

  return <AccountProfile />;
};

export default PerfilPage;
